//src/services/adminSaleBanner.api.js
import { adminApiRequest } from "./adminApi";

// Get sale banner (admin)
export const getAdminSaleBanner = () =>
  adminApiRequest("/sale-banner/admin");

// Save (create/update) sale banner (admin)
export const saveAdminSaleBanner = (data) =>
  adminApiRequest("/sale-banner/admin", {
    method: "POST",
    body: JSON.stringify(data),
  });

// Toggle active/inactive (admin)
export const toggleAdminSaleBanner = () =>
  adminApiRequest("/sale-banner/admin/toggle", {
    method: "PATCH",
  });
